import axios from 'axios'

export default{
    getposts(){
        return axios.get('/helloword').then(response => {
            return response.data
        })
    },
}